export const DISPLAY_MAP = {
  show: 1,
  disable: 0,
  hide: -1,
};

export const FEATURE_IDS_MAP = {
  // Infra > Infra Overview — "Export to Excel" button for checks data
  INFRA_OVERVIEW_EXPORT_CHECKS: "infraOverviewExportChecks",
  // Settings > Policies & Docs — "Add custom policy" menu item in policy list actions
  POLICIES_LIST_ADD_CUSTOM_POLICY: "policiesListAddCustomPolicy",
  // Settings > Policies & Docs — "Download policies" menu item in policy list actions
  POLICIES_LIST_DOWNLOAD_ALL_POLICIES: "policiesListDownloadAllPolicies",
  // Settings > Policies & Docs > Policy Detail — "Download Policy" action in policy detail menu
  POLICY_DETAIL_DOWNLOAD_POLICY: "policyDetailDownloadPolicy",
  // People > Staff List — "Send Reminder" button for policy acknowledgement reminders
  PEOPLE_STAFF_SEND_REMINDER: "peopleStaffSendReminder",
  // People > Staff List — "Export" button to download staff checks data as Excel
  PEOPLE_STAFF_CHECKS_EXCEL_EXPORT: "peopleStaffChecksExcelExport",
  // Risks > Risk Management > Risk Assessment — "Export" button to download assessment risks as Excel
  RISK_ASSESSMENT_EXCEL_EXPORT: "riskAssessmentExcelExport",
  // Tasks — "Export Tasks" button to download tasks as Excel
  TASKS_EXCEL_EXPORT: "tasksExcelExport",
  // Code Security — "Export" button to download repos, branches, and findings as Excel
  CODE_SECURITY_EXCEL_EXPORT: "codeSecurityExcelExport",
  
  // Rego AI evidence collection — dashboard strip, controls column, check suggestions
  REGO_AI_EVIDENCE_COLLECTION: "regoAIEvidenceCollection",
};
